@if (dialog()?.data?.patient) {
<div [innerHTML]="'TherapyJobFinalizeText' | translate: { patientName: dialog().data.patient | personName } | safeHtml">
</div>

<div class="info-box">
    <div class="patient-info">
        <div class="patient-name-row">
            <span class="patient-name">{{ dialog().data.patient | personName }}</span>
            <cw-icon data-test="patient-gender" [icon]="dialog().data.patient?.gender" font="cortex" size="sm" />
        </div>
        <span class="patient-birthdate">{{ dialog().data.patient?.birthDate | localizedDate: dateFormat.BIRTH_DATE
            }}</span>
    </div>

    <cw-divider axis="vertical"></cw-divider>

    <div class="info-item">
        <div class="info-label">{{ 'FormTJCreationMedicine' | translate }}</div>
        <div class="info-value">{{ dialog().data.medicationDisplay }}</div>
    </div>
    <div class="info-item">
        <div class="info-label">{{ 'FormTJCreationDose' | translate }}</div>
        <div class="info-value">
            {{ dialog().data.doseEdited ?? dialog().data.dosePrescribed }} {{ dialog().data.doseUnitPrescribed }}
        </div>
    </div>
    <div class="info-item">
        <div class="info-label">{{ 'FormTJCreationCarrier' | translate }}</div>
        <div class="info-value">{{ dialog().data.carrierEdited ?? dialog().data.carrierPrescribed }}</div>
    </div>
</div>
}

@if (dialog()?.data?.annotations) {
<div class="wrapper">
    <div>{{ 'Annotations' | translate }}</div>
    <div class="annotation-box">
        <div class="info-value">{{ dialog().data.annotations }}</div>
    </div>
</div>
}

<form class="form" [formGroup]="form">
    <h4 class="list-header full-group">{{ 'TherapyJobFinalizeAdministrationInfoHeader' | translate }}</h4>

    <div class="details-row">
        <gplus-datepicker mode="single" [enableTime]="true" instanceId="finalize-job-modal-start"
            attrVef="finalize-job-start" [required]="true" [control]="form.controls['startDateTime']"
            [label]="'TherapyJobFinalizeStartDateLabel' | translate"
            [validations]="{ required: 'TherapyJobFinishInputRequired' | translate }"
            [timeOnly]="true"         
        />

        <gplus-datepicker mode="single" [enableTime]="true" instanceId="finalize-job-modal-end"
            attrVef="finalize-job-end" [required]="true" [control]="form.controls['endDateTime']" [timeOnly]="true"
            [label]="'TherapyJobFinalizeEndDateLabel' | translate" [validations]="{
          required: 'TherapyJobFinishInputRequired' | translate,
          endTimeInFuture: 'TherapyJobFinalizeEndTimeInFuture' | translate,
          endTimeBeforeStart: 'TherapyJobFinalizeEndTimeInvalid' | translate
        }" />

        <gplus-input type="text" attrVef="finalize-job-volume" [required]="true" [measure]="volumeMeasure"
            [label]="'TherapyJobFinalizeVolumeLabel' | translate" [control]="form.controls['infusedVolume']"
            [validations]="{
          required: 'TherapyJobFinishInputRequired' | translate,
          min: 'TherapyJobFinalizeVolumeInvalid' | translate,
          notNumber: 'TherapyJobFinalizeVolumeInvalid' | translate
        }" />

        <gplus-input type="text" attrVef="finalize-job-flow-rate" [measure]="flowRateMeasure"
            [label]="'TherapyJobFinalizeFlowRateLabel' | translate" [control]="form.controls['flowRate']" [validations]="{
          min: 'TherapyJobFinalizeFlowRateInvalid' | translate,
          notNumber: 'TherapyJobFinalizeFlowRateInvalid' | translate
        }" />
    </div>

    <gplus-dropdown class="full-group" attrVef="finalize-job-reason" [required]="true"
        [label]="'TherapyJobFinalizeReasonLabel' | translate"
        [placeholder]="'TherapyJobFinalizeReasonPlaceholder' | translate" [data]="reasonOptions"
        [control]="form.controls['finalizeReason']"
        [validations]="{ required: 'TherapyJobFinishInputRequired' | translate }" />

    @if (showOtherReason()) {
    <gplus-textarea class="full-group" attrVef="finalize-job-reason-other" [required]="true"
        [label]="'TherapyJobFinalizeReasonOtherLabel' | translate" [control]="form.controls['finalizeReasonOther']"
        [maxLength]="finalizeReasonMaxLength" [validations]="{
        maxlength: 'TextareaMaxCharactersError' | translate,
        required: 'TherapyJobFinishInputRequired' | translate
      }" />
    }
</form>

<div class="actions-btns">
    <cw-button button-color="secondary" variant="outlined" (click)="closeDialog()">
        {{ 'TherapyJobFinalizeCloseButton' | translate }}
    </cw-button>

    @if (form.invalid) {
    <!-- Disabled -->
    <cw-tooltip [content]="'TherapyJobFinishDisabledSubmitErrorTooltip' | translate" placement="bottom">
        <cw-button data-test="finalize-job-submit-btn" button-color="accent" variant="filled" [disabled]="true"
            type="submit">
            {{ 'TherapyJobFinalizeSubmitButton' | translate }}
        </cw-button>
    </cw-tooltip>
    } @else {
    <!-- Enabled -->
    <cw-button data-test="finalize-job-submit-btn" button-color="accent" variant="filled" (click)="submitChange()"
        type="submit">
        {{ 'TherapyJobFinalizeSubmitButton' | translate }}
    </cw-button>
    }
</div>